import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { red20, red50 } from '../../constants/colors';

/**
 * 要注意バッジ（#3262）。
 *
 * OCR一覧・OCR詳細（単一項目・明細セル）で共通して使う。
 * あらたオーダーメイドでは同じスタイルが4箇所にコピペされていたため、
 * SaaSでは最初から1コンポーネントに集約する。
 *
 * 色はバリデーションエラーと同じ赤（red50 / 背景 red20）を使う。
 * 要注意はバリデーションエラーと同じ「確認すべき理由」として1行にまとめて表示しており、
 * 色を分けるとかえって優先度が分かりにくくなるため揃えている。
 */

interface ReviewChipProps {
  /** ホバーで出す説明。空なら Tooltip を出さない */
  tooltip?: string;
  /**
   * 件数。2以上のときだけラベルに添える。
   *
   * 現在どの画面からも渡していない（#3328）。一覧の review_item_count は
   * 保存時点の件数で、詳細画面の判定（画面を開いた時点）とズレうるため。
   * 件数を出す判断をしたときにここへ渡す。
   */
  count?: number;
  /** 余白の調整用 */
  marginLeft?: string;
}

export const ReviewChip: React.FC<ReviewChipProps> = ({ tooltip = '', count, marginLeft }) => {
  const label = count !== undefined && count > 1 ? `要注意 ${count}` : '要注意';

  const chip = (
    <Typography
      component="span"
      sx={{
        display: 'inline-block',
        fontSize: '11px',
        lineHeight: '18px',
        padding: '0 6px',
        borderRadius: '4px',
        backgroundColor: red20,
        color: red50,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        ...(marginLeft ? { marginLeft } : {}),
      }}
    >
      {label}
    </Typography>
  );

  if (!tooltip) return chip;

  return (
    <Tooltip title={<Box sx={{ whiteSpace: 'pre-line' }}>{tooltip}</Box>} arrow placement="top">
      {chip}
    </Tooltip>
  );
};

export default ReviewChip;
